import { useParams, useNavigate, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { getVariable } from "../../Helpers/Session";
import ReactToast from "../../components/Toast";
import apiRequest from "../../Api";
import Button from "../../components/Button";
function PurchaseDetails(props) {
  let { id } = useParams();
  const curSymbol = getVariable("curSymbol", true);
  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const [purchaseTotal, setPurchaseTotal] = useState(0);
  let history = useNavigate();
  useEffect(() => {
    if (!id) {
      history("/my-purchases");
    }
  });

  useEffect(() => {
    CallPurchaseDetailApi();
  }, []);
  const CallPurchaseDetailApi = async () => {
    try {
      const url = process.env.REACT_APP_API_BASE;
      let apiSetting = {
        method: "POST",
        apiParams: { purchase_id: id },
      };
      let listingData = await apiRequest(
        `${url}OrderPanelApi/purchaseDetail`,
        apiSetting
      );
      if (listingData?.data && listingData.data.success == 1) {
        setPurchaseDetails(listingData.data.data);
        setPurchaseTotal(listingData.data.data[0].net_amount);
      } else {
        throw new Error(listingData.data.message);
      }
    } catch (error) {
      ReactToast({ type: "error", message: error.message });
      setTimeout(function () {
        history("/my-purchases");
      }, 1000);
    } finally {
    }
  };

  let roundAmount = (amount, floatingPoints) => {
    return parseFloat(amount).toFixed(floatingPoints);
  };

  return (
    <div className="order-detail-page">
      <div className="order-detail-tbl-wrap">
        {purchaseDetails.length > 0 && (
          <div className="ord_info_wrap">
            <div className="ord_no">{purchaseDetails[0]["invoice_no"]}</div>
            <div className="ord_dt">{purchaseDetails[0]["purchase_date"]}</div>
          </div>
        )}
        <table width="100%" cellPadding="5">
          <thead>
            <tr>
              <th align="left">Item</th>
              <th className="qty_head" align="center">Qty</th>
              <th className="ta-right" align="right">Rate</th>
              <th className="ta-right" align="right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {purchaseDetails.length > 0 &&
              purchaseDetails.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {item.item_title}
                      {item.unit_title && (
                        <p className="unit_rate_txt">
                          Rate in {item.unit_title}
                        </p>
                      )}
                    </td>
                    <td align="center">{item.item_wise_qty}</td>

                    <td align="right">{roundAmount(item.unit_price, 2)}</td>
                    <td align="right">{roundAmount(item.total_amount, 2)}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      {purchaseDetails.length > 0 && purchaseDetails && (
        <div className="page-footer">
          <div className="summary">
            <label>Purchase Amount</label>
            <div className="total">
              {curSymbol}
              {purchaseTotal}
            </div>
          </div>
          <NavLink to="/my-purchases">
            <Button
              className="bg-red-400 p-2 rounded text-white"
              title="Back"
              type="button"
            />
          </NavLink>
        </div>
      )}
    </div>
  );
}

export default PurchaseDetails;
